import { ROUTES } from '@/utils'

export const CHECKOUT_FLOW_ROUTES = [
  ROUTES.PACKAGE.REVIEW_PACKAGE,
  ROUTES.PACKAGE.CHECKOUT,
  ROUTES.PACKAGE.ORDER.IN_PROGRESS,
  ROUTES.PACKAGE.ORDER_INCOMPLETE,
  ROUTES.PACKAGE.ORDER_CONFIRMATION,
]
